import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import {
  CCreateElement,
  CSidebar,
  CSidebarBrand,
  CSidebarNav,
  CSidebarNavDivider,
  CSidebarNavTitle,
  CSidebarMinimizer,
  CSidebarNavDropdown,
  CSidebarNavItem,
} from "@coreui/react";

import CIcon from "@coreui/icons-react";

// sidebar nav config
import navigation from "./_nav";
import { setMenuToggle } from "../redux/actions";
import Logo from "../assets/logos/logo.png";

const TheSidebar = (props) => {
  const [url, setUlr] = useState("/");

  useEffect(() => {
    //const role = local.user? local.user.role: null;
    setUlr("/");
  }, []);

  const navs = [];
  const { menus, show } = props;
  // if we want to show the widget UI component we have to change all the menusFiletered for menus
  const menusFiltered = menus.filter((menu) => menu.id !== 3);

  if (menusFiltered) {
    navigation.forEach((nav) => {
      if (nav._tag === "CSidebarNavDropdown") {
        nav._children = [];
        menusFiltered.forEach((menu) => {
          if (menu.parent && nav._tag === "CSidebarNavDropdown") {
            nav.children.forEach((n) => {
              if (menu.name === n.name) {
                nav._children.push(n);
              }
            });
          }
        });
      }
    });
    navigation.forEach((nav) => {
      if (nav.name) {
        if (nav._tag === "CSidebarNavDropdown" && nav._children.length) {
          navs.push(nav);
        }
        menusFiltered.forEach((menu) => {
          if (menu.name === nav.name) {
            navs.push(nav);
          }
        });
      } else {
        navs.push(nav);
      }
    });
  }

  return (
    <CSidebar
      show={show}
      onShowChange={(val) => props.setMenuToggle(val)}
      style={{
        background:
          "linear-gradient(0.50turn,#1A1940, #1A1940, #1A1940 ,#F24968)",
        transition: "background 0.3s ease",
      }}
    >
      <CSidebarBrand
        className="d-md-down-none"
        to={url}
        style={{
          background: "linear-gradient(0.50turn, #2D1959,#1A1940)",
          transition: "background 0.3s ease",
        }}
      >
        <img src={Logo} alt="Carbonatixaudio logo" style={{ width: "47px" }} />
      </CSidebarBrand>
      <CSidebarNav>
        <CCreateElement
          items={navs}
          components={{
            CSidebarNavDivider,
            CSidebarNavDropdown,
            CSidebarNavItem,
            CSidebarNavTitle,
          }}
        />
      </CSidebarNav>
      <CSidebarMinimizer className="c-d-md-down-none" />
    </CSidebar>
  );
};
const mapStateToProps = (state) => ({
  show: state.setting.sidebarShow,
  menus: state.common.menus,
  user: state.auth.user,
});
export default connect(mapStateToProps, { setMenuToggle })(
  React.memo(TheSidebar)
);
